export default [
  {
    sno: "0120",
    id: "01",

    createdate: "20 Nov 2021",
  },
];
